import React from "react";
import styled from "styled-components";
import { AnimatedTab } from "components/ui/animated/AnimatedTab";
import { useUpdateUrlParams } from "hooks/useUpdateUrlParams";
import { membersDashboardTabOptions } from "constants/businessDashboard";

const BorderBottom = styled.div`
  border-bottom: 1px solid #d1d3d7;
  padding: 0 16px;
`;

export const MembersDashboardTabs = () => {
  const { searchParams, updateUrlParams } = useUpdateUrlParams();
  const activeTab = searchParams.get("tab") || membersDashboardTabOptions[0].id;

  const handleTabChange = (newTab: string) => {
    updateUrlParams({ tab: newTab });
  };

  return (
    <BorderBottom>
      <AnimatedTab
        tabs={membersDashboardTabOptions}
        gap={0}
        minWidth={60}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </BorderBottom>
  );
};
